"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
export default function NaturalColorsExplosion() {
  const particles = Array.from({
    length: 15
  });
  return <section data-section-id="222610" id="hero" className="relative w-full min-h-screen bg-background text-foreground overflow-hidden flex flex-col lg:flex-row">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes float-petal {
          0% { transform: translateY(10vh) translateX(0) rotate(0deg) scale(0.8); opacity: 0; }
          20% { opacity: 0.4; }
          80% { opacity: 0.4; }
          100% { transform: translateY(-100vh) translateX(20vw) rotate(360deg) scale(1.2); opacity: 0; }
        }
        .animate-petal {
          animation: float-petal 15s linear infinite;
        }
      `
    }} />

      {}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" aria-hidden="true">
        {particles.map((_, i) => <div key={i} data-index={i} className="absolute animate-petal rounded-full bg-primary/20 backdrop-blur-sm" style={{
        width: `${Math.random() * 20 + 10}px`,
        height: `${Math.random() * 20 + 10}px`,
        left: `${Math.random() * 100}%`,
        bottom: `-5%`,
        animationDelay: `${Math.random() * 15}s`,
        animationDuration: `${Math.random() * 10 + 15}s`
      }} />)}
      </div>

      {}
      <div className="relative w-full lg:w-[60%] h-[50vh] lg:h-auto min-h-[50vh] lg:min-h-screen z-10">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619832/img/enterprise_change_consulting.png" alt="Enterprise consulting visual" className="absolute inset-0 w-full h-full object-cover object-center" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-background/40 lg:to-transparent" />
      </div>

      {}
      <div className="relative w-full lg:w-[40%] flex items-center justify-center p-6 sm:p-10 lg:p-12 z-20 -mt-20 lg:mt-0 lg:-ml-24">
        <Card className="w-full max-w-lg bg-card/80 backdrop-blur-xl shadow-2xl border-border/50 rounded-2xl overflow-hidden">
          <CardHeader className="pb-4">
            <CardTitle className="font-default text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight tracking-tighter">
              Enterprise Change through Strategic <br className="hidden sm:block" />
              <span className="text-primary italic font-light">Consulting</span>
            </CardTitle>
          </CardHeader>
          <CardContent className="flex flex-col gap-8">
            <CardDescription className="font-sans text-lg sm:text-xl text-muted-foreground leading-relaxed">
              Delivering expert business analysis, risk management, and project certainty for Western Australia's most complex enterprise transformations since 1998.
            </CardDescription>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-8 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 transition-transform hover:-translate-y-1 hover:bg-primary/90">
                <Link to="#">
                  Start Project
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}